import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  UpdatedMotivatesYouArray: [],
  visibleEditOption: false,
  stepNo: 0,
};

const motivatesYouSlice = createSlice({
  name: "motivatesYou",
  initialState,
  reducers: {
    saveUpdatedMotivatesYouArray(state, action) {
      state.UpdatedMotivatesYouArray = action.payload;
    },
    saveVisibleEditOption(state, action) {
      state.visibleEditOption = action.payload;
    },
    saveStepNo(state, action) {
      state.stepNo = action.payload;
    },
  },
});

export const {
  saveUpdatedMotivatesYouArray,
  saveVisibleEditOption,
  saveStepNo,
} = motivatesYouSlice.actions;

export default motivatesYouSlice.reducer;
